import React from 'react';
import { createRoot } from 'react-dom/client';
import AppWithAuth from './AppWithAuth';
import '../i18next.config';

// CloudWatch RUM is initialized at bootstrap inside AppWithAuth (before the auth
// gate, right after Amplify.configure) via initRum(), so pre-login/auth errors
// are captured via guest-role ingestion. See
// docs/observability/clinician-portal-rum-plan.md.

createRoot(document.getElementById('root')).render(<AppWithAuth />);
